import React from 'react';
import { Select } from 'antd';
import styled from 'styled-components';

import { FormFieldLabel } from './FormFieldLabel';
import { StyledFormItem } from './FormInput';
import { FormSelectProps } from './FormSelect';

const StyledSelector = styled(StyledFormItem)`
  .ant-select-selection-item {
    color: #212121;
    padding-right: 10px;
    padding-left: 10px;
    border-radius: 14px;
    background-color: white;
    font-weight: 550;
    border: 1px solid #e0e0e0;
  }
`;

export const FormSelectMultiple: React.FC<FormSelectProps> = ({
  name,
  label,
  options,
  required,
  mode = 'multiple',
  rules,
  dependencies,
  preserve,
}) => {
  const mappedOptions = options
    .filter((option) => option.content !== 'Unknown')
    .map((option) => ({
      value: option.value,
      label: option.content,
      key: option.value,
    }));

  return (
    <StyledSelector
      name={name}
      rules={rules}
      dependencies={dependencies}
      preserve={preserve}
      label={<FormFieldLabel required={required}>{label}</FormFieldLabel>}
    >
      <Select
        mode={mode}
        allowClear
        showArrow
        options={mappedOptions}
        filterOption={(inputValue, option) => {
          return (option?.label?.toString().toLowerCase() ?? '').includes(inputValue.toLowerCase());
        }}
      />
    </StyledSelector>
  );
};
